import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Chart, registerables } from "chart.js";
import { Pie } from "react-chartjs-2";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ChartDataLabels from "chartjs-plugin-datalabels";
import zoomPlugin from 'chartjs-plugin-zoom';
import circle from './circle.png';
import { API_BASE_URL } from './config';
import "./style.css";
import "./FrequencyResponseFunction.css";
Chart.register(ChartDataLabels);
Chart.register(...registerables, zoomPlugin);

const VFRFX = () => {
  const navigate = useNavigate();
  const onMachineManagement = (e) => {
    e.preventDefault();
    navigate('/machine-management');
  };
  const onMachineCreate = (e) => {
    e.preventDefault();
    navigate('/grading-frequency-response-function/x');
  };

  const { axis } = useParams();
  const [activeTab, setActiveTab] = useState(axis || "X");
  useEffect(() => {
    setActiveTab(axis || "X");
  }, [axis]);

  const [machineList, setMachineList] = useState([]);
  const [userDepartment, setUserDepartment] = useState(""); // 新增：狀態來儲存使用者部門
      
  useEffect(() => {
    // 從 localStorage 取得部門資訊
    const dept = localStorage.getItem("department"); 
    setUserDepartment(dept || ""); // 如果沒有找到，預設為空字串
  }, []);

  // 從後端取得機台資料(formData)
  const fetchMachineData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getdata/formData`);
      console.log('MachineManagement', response.data);
      setMachineList(response.data);
    } catch (error) {
      console.error('獲取機台資料失敗:', error);
    }
  };

  const [showModal, setShowModal] = useState(false);

  // 抓取機台資料進圖示資料，且顯示型號
  const handleShowModal = () => {
    fetchMachineData();
    setShowModal(true);
  };

  const [selectedMachines, setSelectedMachines] = useState([]);

  // 處理圖式資料中的勾選&取消勾選
  const handleCheckboxChange = (index) => {
    const selectedMachine = machineList.find((m) => m._id === index);
    if (!selectedMachine) return;
    if (selectedMachines.length === 0) {
      setSelectedMachines([index]);
    } else {
      const firstSelectedMachine = machineList.find((m) => m._id === selectedMachines[0]);
      if (firstSelectedMachine && firstSelectedMachine.machineModel.split('-')[0] === selectedMachine.machineModel.split('-')[0]) {
        setSelectedMachines((prevSelected) =>
          prevSelected.includes(index)
            ? prevSelected.filter((id) => id !== index)
            : [...prevSelected, index]
        );
      }
    }
  };

  const [coverData, setcoverData] = useState([]);
  const [lineLabels, setlineLabels] = useState([]);

  const [okCount, setOkCount] = useState(0);
  const [ngCount, setNgCount] = useState(0);
  const [okMachineModel, setOkMachineModel] = useState([]);
  const [ngMachineModel, setNgMachineModel] = useState([]);

  // 圖式資料 確認按鈕
  const handleConfirmSelection = () => {
    // 提取勾選的資料
    const newChartData = selectedMachines.map((machineId) => {
      const machine = machineList.find((m) => m._id === machineId);
      if (!machine) return null; // 如果找不到，跳過

      // 處理頻率&振幅
      const freq = Array.isArray(machine.updataX.Amp_peak_data)
        ? machine.updataX.Amp_peak_data
        : [machine.updataX.Amp_peak_data];
      const amplitude = Array.isArray(machine.updataX.Amp_peak_freq_data)
        ? machine.updataX.Amp_peak_freq_data
        : [machine.updataX.Amp_peak_freq_data];

      // 將頻率&振幅的資料攤平成一維陣列
      const extractedFreq = freq.flat();
      const extractedAmplitude = amplitude.flat();

      return {
        machineModel: machine.machineModel,
        label: machine.updataX.chartData.ch_name,
        amp_peak_data: extractedFreq,
        amp_peak_freq_data: extractedAmplitude,
        data: (Array.isArray(machine.updataX.chartData.magn)
          ? machine.updataX.chartData.magn
          : [machine.updataX.chartData.magn]).slice(9),
        labels: machine.updataX.chartData.freq.slice(9),
        fill: true,
        tension: 0.4,
        labels: machine.updataX.chartData.freq,
        //isNG: false // 初始值
      };
    }).filter(item => item !== null);

    setcoverData(newChartData);
    setlineLabels(newChartData[0]?.labels.slice(9) || []);
    setShowModal(false);

    let okCount = 0;
    let ngCount = 0;
    let ngMachineModel = [];
    let okMachineModel = [];

    if (newChartData.length > 0) {
      const firstSelectedMachine = machineList.find(
        (m) => m._id === selectedMachines[0]
      );
      const baselineMachine = machineList.find((m) => {
        const currentModelPrefix = m.machineModel.split('-')[0];
        const selectedModelPrefix = firstSelectedMachine.machineModel.split('-')[0];
        return currentModelPrefix === selectedModelPrefix;
      });
      const firstFreqData = baselineMachine.updataX.Amp_peak_freq_data;
      const firstAmpPeakData = baselineMachine.updataX.Amp_peak_data;

      // OK&NG 判斷
      newChartData.forEach((item) => {
        let isNG = false;
        /*if (item.amp_peak_freq_data) {
          item.amp_peak_freq_data.forEach((value, i) => {
            const result = Math.abs((value - firstFreqData[i]) / firstFreqData[i]) * 100;
            if (result < 0 || result > 30) {
              isNG = true;
            }
          });
        }*/
        if (item.amp_peak_freq_data) {
          item.amp_peak_freq_data.forEach((value) => {
            // 找 firstFreqData 裡第一筆在 ±1Hz 的基準頻率
            const match = firstFreqData.find(baseFreq => {
              return Math.abs(value - baseFreq) <= 1;
            });
            // 如果有找到對應的基準頻率，就進行判斷
            if (match !== undefined) {
              const result = Math.abs((value - match) / match) * 100;
              if (result < 0 || result > 10) {
                isNG = true;
              }
            }
          });
        }
        /*if (item.amp_peak_data) {
          item.amp_peak_data.forEach((value, i) => {
            const result = Math.abs((value - firstAmpPeakData[i]) / firstAmpPeakData[i]) * 100;
            if (result < 0 || result > 30) {
              isNG = true;
            }
          });
        }*/
        if (item.amp_peak_data && item.amp_peak_freq_data) {
          item.amp_peak_data.forEach((ampValue, i) => {
            const freqValue = item.amp_peak_freq_data[i];
            // 找到符合 ±1Hz 的基準頻率位置
            const matchIndex = firstFreqData.findIndex(baseFreq => {
              return Math.abs(freqValue - baseFreq) <= 1;
            });
            // 如果找到對應的頻率，才進行振幅比對
            if (matchIndex !== -1) {
              const baseAmp = firstAmpPeakData[matchIndex];
              const result = Math.abs((ampValue - baseAmp) / baseAmp) * 100;
              if ((ampValue >= 0.05 && result > 10) || (ampValue < 0.05 && result > 30)) {
                isNG = true;
              }
            }
          });
        }

        console.log(`${item.label} - OK/NG判斷 : ${isNG ? 'NG' : 'OK'}`);
        item.isNG = isNG;
        if (isNG) {
          ngCount++;
          ngMachineModel.push(item.machineModel);
        } else {
          okCount++;
          okMachineModel.push(item.machineModel);
        }
      });
    }

    // 更新狀態
    setOkCount(okCount);
    setNgCount(ngCount);
    setOkMachineModel(okMachineModel);
    setNgMachineModel(ngMachineModel);

    // 更新localStorage (在 OK&NG 判斷後)
    localStorage.setItem("selectedMachinesX", JSON.stringify(selectedMachines));
    localStorage.setItem("coverDataX", JSON.stringify(newChartData));
  };

  // 頁面刷新後，恢復資料
  useEffect(() => {
    const savedSelectedMachines = JSON.parse(localStorage.getItem("selectedMachinesX"));
    const savedCoverData = JSON.parse(localStorage.getItem("coverDataX"));

    // 如果localStorage有資料，恢復數據
    if (savedSelectedMachines && savedCoverData) {
      setSelectedMachines(savedSelectedMachines);
      setcoverData(savedCoverData);
      setlineLabels(savedCoverData[0]?.labels.slice(9) || []);
    }
  }, []);

  const lineChartRef = useRef(null);

  // 折線圖
  const createLineChart = (chartRef, datasets) => {
    // deep cloned datasets，避免被Chart.js修改
    const clonedDatasets = JSON.parse(JSON.stringify(datasets));

    // 使用 deep cloned 資料
    const chartInstance = new Chart(lineChartRef.current, {
      type: "line",
      data: { labels: chartRef, datasets: clonedDatasets },
      options: {
        layout: { padding: { right: -80 } }, // 折線圖 圖例位置
        scales: {
          y: {
            ticks: { beginAtZero: true },
            title: { display: true, text: 'Amplitude (μm/N)', font: { size: 14 }, padding: 15 }
          },
          x: {
            type: 'linear', min: 15, max: 200,
            title: { display: true, text: 'Frequency (Hz)', font: { size: 14 }, padding: 15 },
            ticks: { beginAtZero: true, stepSize: 1, callback: function (value) { return Math.round(value); } }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        fill: true,
        elements: {
          point: { radius: 0, hitRadius: 10 },
          line: { tension: 0.4 }
        },
        plugins: {
          legend: {
            position: 'bottom',
            display: true,
            labels: { usePointStyle: true, pointStyle: 'rect', font: { size: 12 } }, // 折線圖 圖例尺寸
            onClick: (e, legendItem, legend) => {
              // 取得被點擊的圖例資訊
              const datasetIndex = legendItem.datasetIndex;
              const chart = legend.chart;

              // 控制顯示&隱藏
              const meta = chart.getDatasetMeta(datasetIndex);
              meta.hidden = !meta.hidden;
              const isHidden = meta.hidden;

              // 判斷資料是否NG
              const isNG = chart.data.datasets[datasetIndex].isNG;
              const machineModel = chart.data.datasets[datasetIndex].machineModel;

              if (isHidden) {
                if (isNG) {
                  setNgCount((prev) => prev - 1);
                  setNgMachineModel((prev) => {
                    const index = prev.indexOf(machineModel);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1); // 如果有相同的machineModel，只刪除第一個找到的
                      return newMachines;
                    }
                    return prev;
                  });
                  //console.log(`隱藏 NG 數據: "${chart.data.datasets[datasetIndex].label}"`);
                } else {
                  setOkCount((prev) => prev - 1);
                  setOkMachineModel((prev) => {
                    const index = prev.indexOf(machineModel);
                    if (index !== -1) {
                      const newMachines = [...prev];
                      newMachines.splice(index, 1); // 如果有相同的machineModel，只刪除第一個找到的
                      return newMachines;
                    }
                    return prev;
                  });
                  //console.log(`隱藏 OK 數據: "${chart.data.datasets[datasetIndex].label}"`);
                }
              } else {
                if (isNG) {
                  setNgCount((prev) => prev + 1);
                  setNgMachineModel((prev) => [...prev, machineModel]);
                  //console.log(`顯示 NG 數據: "${chart.data.datasets[datasetIndex].label}"`);
                } else {
                  setOkCount((prev) => prev + 1);
                  setOkMachineModel((prev) => [...prev, machineModel]);
                  //console.log(`顯示 OK 數據: "${chart.data.datasets[datasetIndex].label}"`);
                }
              }
              chart.update();
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (context) {
                const label = context.dataset.label || '';
                const xValue = context.label;
                const yValue = context.raw.toFixed(4);
                return `${label}   ( ${xValue} , ${yValue} )`;
              },
              title: () => ''
            }
          },
          datalabels: { display: false },
          zoom: {
            pan: { enabled: false },
            zoom: {
              wheel: { enabled: false },
              pinch: { enabled: false },
              mode: 'x',
              drag: { enabled: true, backgroundColor: 'rgba(0, 0, 0, 0.1)', threshold: 2, delay: 50 }
            },
            onZoom: ({ chart }) => {
              let xScale = chart.scales.x;
              let min = Math.max(xScale.min, 15);
              let max = Math.min(xScale.max, 200);

              chart.options.scales.x.min = min;
              chart.options.scales.x.max = max;
              chart.options.scales.x.ticks.stepSize = 1;
              chart.update();
            }
          }
        }
      }
    });

    lineChartRef.current.chartInstance = chartInstance;

    let okCount = 0;
    let ngCount = 0;
    let okMachines = [];
    let ngMachines = [];

    // 使用原本的datasets計數，並使用cloned Datasets確保一致性
    clonedDatasets.forEach((dataset, i) => {
      const meta = chartInstance.getDatasetMeta(i);
      console.log(`dataset[${i}]: hidden = ${meta.hidden}`);
      const isHidden = meta.hidden === true;

      if (!isHidden) {
        const isNG = dataset.isNG === true;
        const machineModel = dataset.machineModel;

        if (isNG) {
          ngCount++;
          ngMachines.push(machineModel);
        } else {
          okCount++;
          okMachines.push(machineModel);
        }
      }

      /*確認isNG刷新後是否依舊正確*/
      //console.log(`dataset[${i}]: label = ${dataset.label}, isNG = ${dataset.isNG}, type = ${typeof dataset.isNG}`);
    });

    setOkCount(okCount);
    setNgCount(ngCount);
    setOkMachineModel(okMachines);
    setNgMachineModel(ngMachines);

    return chartInstance;
  };

  const resetZoom = () => {
    if (lineChartRef.current && lineChartRef.current.chartInstance) {
      lineChartRef.current.chartInstance.resetZoom();
    }
  };

  // 確保折線圖創建
  useEffect(() => {
    let lineChart;
    if (lineChartRef.current) lineChart?.destroy();
    lineChart = createLineChart(lineLabels, coverData);
    return () => {
      lineChart?.destroy();
    };
  }, [coverData]);

  // 切換到不同軸向後，重新處理選中的機台數據，更新折線圖
  useEffect(() => {
    if (selectedMachines.length > 0) {
      handleConfirmSelection();
    }
  }, [activeTab]);

  // 圓餅圖
  const createChartData = (okCount, ngCount, okMachineModel, ngMachineModel) => {
    return {
      data: {
        labels: ["GO", "NO GO"],
        datasets: [{
          data: [okCount, ngCount],
          backgroundColor: ["rgba(91, 130, 177, 1)", "rgba(255, 105, 91, 1)"],
          okMachineModel: okMachineModel,
          ngMachineModel: ngMachineModel
        }]
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            display: true,
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              font: { size: 15 }, //圓餅圖 圖例尺寸
              padding: 50 // 圓餅圖 圖例位置
            },
            onClick: () => { }
          },
          datalabels: {
            display: true,
            color: '#ffffff',
            font: { size: 18 }, // 圓餅圖 %數值尺寸
            formatter: (value, context) => {
              const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
              const percentage = ((value / total) * 100).toFixed(0);
              return `${percentage}%`;
            }
          },
          tooltip: {
            enabled: false, // 禁用內建tooltip，使用自訂tooltip
            external: function (context) {
              let tooltipEl = document.getElementById("chart-tooltip");

              if (!tooltipEl) {
                tooltipEl = document.createElement("div");
                tooltipEl.id = "chart-tooltip";
                tooltipEl.style.position = "absolute";
                tooltipEl.style.background = "rgba(0, 0, 0, 0.8)";
                tooltipEl.style.color = "white";
                tooltipEl.style.padding = "8px";
                tooltipEl.style.borderRadius = "5px";
                tooltipEl.style.fontSize = "13px";
                tooltipEl.style.pointerEvents = "none";
                tooltipEl.style.transition = "opacity 0.2s";
                tooltipEl.style.zIndex = "3"; // 確保tooltip顯示在最上層
                document.body.appendChild(tooltipEl);
              }

              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = "0";
                return;
              }

              const dataPoint = tooltipModel.dataPoints[0];
              const dataset = dataPoint.dataset;

              let tooltipText = "";
              if (dataPoint.label === "GO") {
                tooltipText = ` ${dataset.okMachineModel}`;
              } else if (dataPoint.label === "NO GO") {
                tooltipText = ` ${dataset.ngMachineModel}`;
              }

              tooltipEl.innerHTML = tooltipText; // 套用給tooltip的內容，上一段為內容的宣告
              tooltipEl.style.opacity = "1"; // tooltip透明度，範圍0-1

              // 正確計算 tooltip 位置，在滑鼠附近顯示
              document.addEventListener("mousemove", (event) => {
                tooltipEl.style.left = `${event.clientX + 15}px`;
                tooltipEl.style.top = `${event.clientY + 5}px`;
              });
            }
          }
        }
      }
    };
  };

  // 呼叫createChartData，傳入okCount、ngCount、okMachineModel、ngMachineModel，回傳給data1
  const data1 = createChartData(okCount, ngCount, okMachineModel, ngMachineModel);

  //圖示資料 全選功能
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleToggleSelectAll = () => {
    const modelPrefix = machineList.find(m => m._id === selectedMachines[0])?.machineModel.split('-')[0];
    if (!isAllSelected) {
      const sameModelMachines = machineList
        .filter(machine => machine.machineModel.split('-')[0] === modelPrefix)
        .map(machine => machine._id);

      setSelectedMachines(sameModelMachines);
      setIsAllSelected(true);
    } else {
      setSelectedMachines([]);
      setIsAllSelected(false);
    }
  };

  return (
    <div className="d-flex" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" onClick={onMachineManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>機台資料庫</a>
            </li>
            <li
              className="breadcrumb-item active"
              aria-current="page"
              style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>頻率響應函數
            </li>
          </ol>
        </nav>

        <div className="d-flex justify-content-end gap-3">
          <button
            className="reset-btn btn-margin-sm bi bi-arrow-clockwise"
            style={{
              height: '35px',
              width: '40px',
              display: 'inline-block',
              textAlign: 'center',
              lineHeight: '35px',
              backgroundColor: '#007bff',
              color: '#fff',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
            onClick={resetZoom}
          >
          </button>

          <button
            className="btn1 btn-margin-sm"
            style={{ height: '35px', width: '75px' }}
            onClick={onMachineCreate}
          >
            等級分析
          </button>

          <div className="d-flex justify-content-end" style={{ paddingRight: '20px' }}>
            <button
              className="btn2 btn-margin-sm"
              style={{ height: '35px', width: '75px' }}
              onClick={() => { setShowModal(true); handleShowModal(); }}
            >
              圖示資料
            </button>
          </div>
        </div>

        <nav>
          <div className="nav nav-tabs" role="tablist">
            {["X", "Y", "Z"].map((axis) => (
              <Link
                key={axis}
                to={`/view-frequency-response-function/${axis.toLowerCase()}`}
                className={`nav-link ${activeTab === axis ? "active" : ""}`}
              >
                {axis}軸向
              </Link>
            ))}
          </div>
        </nav>
        <div style={{ height: '30px', width: '100%' }}></div>

        <div className="d-flex flex-column flex-md-row align-items-center">

          <div className="w-100 order-2 order-md-1" style={{ height: '565px', marginTop: '95px' }}>
            <canvas ref={lineChartRef} style={{ height: '100%' }}></canvas>
          </div>

          <div className="d-flex chart-container flex-column  justify-content-center align-items-center order-1 order-md-2"
            style={{ position: "relative", width: "400px", height: "450px", display: "flex", border: "1px solid #E3E3E3", justifyContent: "center" }}
          >
            <div className="d-flex justify-content-center" style={{ position: "relative", width: "100%", height: "60px" }}>
              <p className="chart-text chart-text-sm " >
                <span style={{ color: "rgba(91, 130, 177, 1)", fontSize: '25px', fontWeight: 'bold' }}>GO</span>
                <span style={{ color: "rgb(107, 107, 107)", fontSize: '25px', fontWeight: 'bold' }}> / </span>
                <span style={{ color: "rgba(255, 105, 91, 1)", fontSize: '25px', fontWeight: 'bold' }}>NO GO</span>
              </p>
            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex justify-content-center align-items-center"
              style={{ position: "relative", width: "100%", height: "280px", marginTop: "10px" }}
            >
              <Pie data={data1.data} options={data1.options} />

              <img
                src={circle}
                alt="circle"
                style={{
                  width: "260px",
                  height: "260px",
                  position: "absolute",
                  top: "37%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  pointerEvents: "none"
                }} />
            </div>
          </div>

        </div>
        <div style={{ height: '50px', width: '100%' }}></div>

        <Modal show={showModal} onHide={() => setShowModal(false)} scrollable>
          <Modal.Header closeButton>
            <Modal.Title>圖示資料選擇</Modal.Title>
            {selectedMachines.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className={`select-model-button ${isAllSelected ? 'cancel' : 'select'}`}
                  onClick={handleToggleSelectAll}
                  style={{
                    padding: '2px 10px',
                    height: '28px',
                    lineHeight: '1.2',
                    marginLeft: '12px',
                    marginTop: '15px'
                  }}
                >
                  {isAllSelected
                    ? '取消全選'
                    : `全選：${machineList.find(m => m._id === selectedMachines[0])?.machineModel.split('-')[0]}`}
                </Button>
              </div>
            )}
          </Modal.Header>
          <Modal.Body>
            {machineList
              .filter((machine) => {
                return machine.department === userDepartment;
              })
              .map((machine) => {
                const isDisabled = selectedMachines.length > 0 && (
                  machineList.find((m) => m._id === selectedMachines[0]).machineModel.split('-')[0] !== machine.machineModel.split('-')[0]
                );
                return (
                  <div
                    key={machine._id}
                    style={{ marginBottom: '10px' }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={machine._id}
                      id={`modal-machine-${machine._id}`}
                      checked={selectedMachines.includes(machine._id)}
                      onChange={() => handleCheckboxChange(machine._id)}
                      disabled={isDisabled}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`modal-machine-${machine._id}`}
                      style={{ marginLeft: '10px', color: isDisabled ? '#A9A9A9' : '#636363' }}
                    >
                      {machine.updataX.chartData.filename}
                    </label>
                  </div>
                );
              })}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center gap-4">
            <Button
              className="btn-cancel"
              style={{ height: '35px', width: '75px' }}
              onClick={() => setShowModal(false)}
            >
              取消
            </Button>
            <Button
              variant="btn-confirm btn-primary"
              style={{ height: '35px', width: '75px' }}
              onClick={handleConfirmSelection}
            >
              確認
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div >
  );
};

export default VFRFX;